module.exports = __webpack_public_path__ + "img/phone-outline-icon.42a059fa.svg";